module.exports = __webpack_public_path__ + "images/help/icn-faq-mobile-be7c50205ed355bd262469a987ffe3a7.png";